import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Coin.png'


const _withScopeId = n => (_pushScopeId("data-v-0e049b12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topbar" }
const _hoisted_2 = { class: "topbar__items" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "topbar__logo",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.292 11.179C1.24921 19.457 7.84945 25.1391 11.9404 27C10.5123 24.8497 11.4513 21.3642 12.6141 20.2778C17.3386 26.1173 19.0829 18.3086 17.6292 15.5926C23.3712 18.9198 23.0233 24.1742 21.3125 27C33.9202 19.143 23.171 6.55072 12.2369 5C13.8733 6.68856 13.7633 9.14198 11.292 11.179Z",
    fill: "#2FF77A"
  })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "topbar__item topbar__tag topbar__tag-amount"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 25 25",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M20.5547 21.6174V19.6174C20.5547 18.5566 20.1333 17.5392 19.3831 16.789C18.633 16.0389 17.6156 15.6174 16.5547 15.6174H8.55469C7.49382 15.6174 6.47641 16.0389 5.72626 16.789C4.97611 17.5392 4.55469 18.5566 4.55469 19.6174V21.6174",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.5547 11.6175C14.7638 11.6175 16.5547 9.82663 16.5547 7.61749C16.5547 5.40835 14.7638 3.61749 12.5547 3.61749C10.3455 3.61749 8.55469 5.40835 8.55469 7.61749C8.55469 9.82663 10.3455 11.6175 12.5547 11.6175Z",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 25 25",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19.2192 3.44659H5.21924C4.11467 3.44659 3.21924 4.34202 3.21924 5.44659V19.4466C3.21924 20.5512 4.11467 21.4466 5.21924 21.4466H19.2192C20.3238 21.4466 21.2192 20.5512 21.2192 19.4466V5.44659C21.2192 4.34202 20.3238 3.44659 19.2192 3.44659Z",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.71924 10.4466C9.54767 10.4466 10.2192 9.77502 10.2192 8.94659C10.2192 8.11817 9.54767 7.44659 8.71924 7.44659C7.89081 7.44659 7.21924 8.11817 7.21924 8.94659C7.21924 9.77502 7.89081 10.4466 8.71924 10.4466Z",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21.2192 15.4466L16.2192 10.4466L5.21924 21.4466",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_7 = { class: "topbar__items" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M3.21137 8.24406C3.52118 4.52635 6.62899 1.66675 10.3596 1.66675C14.0902 1.66675 17.198 4.52635 17.5078 8.24406L17.8203 11.9934C17.8482 12.3287 17.9546 12.6516 18.1037 13.1006C18.5506 14.4466 17.6437 15.8622 16.2342 16.0189C15.3804 16.1138 14.5248 16.1879 13.6682 16.2413C13.467 17.8899 12.0624 19.1667 10.3596 19.1667C8.65676 19.1667 7.25218 17.8899 7.05096 16.2415C6.19418 16.1881 5.33837 16.114 4.48432 16.0191C3.0737 15.8623 2.16625 14.4448 2.61519 13.098C2.76465 12.6496 2.87116 12.3265 2.8991 11.9913L3.21137 8.24406ZM8.76521 16.3205C8.97358 17.0034 9.60856 17.5001 10.3596 17.5001C11.1106 17.5001 11.7456 17.0033 11.9539 16.3205C10.8913 16.3524 9.82788 16.3524 8.76521 16.3205ZM10.3596 3.33341C7.49581 3.33341 5.1101 5.52858 4.87228 8.38247L4.56001 12.1297C4.51479 12.6723 4.3493 13.1674 4.21657 13.5645C4.20973 13.5849 4.20297 13.6051 4.19632 13.6251C4.08304 13.9649 4.31203 14.323 4.66838 14.3626C5.74304 14.482 6.82057 14.5675 7.89934 14.619C9.53853 14.6973 11.1806 14.6973 12.8198 14.6189C13.8983 14.5673 14.9756 14.4818 16.0501 14.3624C16.4058 14.3228 16.6348 13.9655 16.522 13.6258C16.515 13.6048 16.5079 13.5834 16.5007 13.5618C16.3688 13.166 16.2044 12.6723 16.1593 12.1318L15.8469 8.38247C15.6091 5.52858 13.2234 3.33341 10.3596 3.33341Z",
    fill: "white"
  })
], -1))
const _hoisted_9 = { class: "topbar__item topbar__tag" }
const _hoisted_10 = {
  width: "17",
  height: "16",
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_11 = ["fill"]
const _hoisted_12 = { class: "topbar__item topbar__tag" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

import { onBeforeMount, computed, ref, Ref } from 'vue';
import { AuthService } from '@/services/AuthService';
import { ProfileService } from '@/services/ProfileService';
import { TimerSevice } from '@/services/TimerService';
import { Stats, TopService } from '@/services/TopService';

// Timer to next theme

export default /*#__PURE__*/_defineComponent({
  __name: 'TheTopbar',
  setup(__props) {

const remainTime = ref(TimerSevice.getRemainTime());
const remainMinutes = computed(() =>
	remainTime.value.getMinutes().toString().padStart(2, '0')
);
const remainSeconds = computed(() =>
	remainTime.value.getSeconds().toString().padStart(2, '0')
);
setInterval(() => {
	remainTime.value = TimerSevice.getRemainTime();
}, 1000);

// Get balance & amounts
const balance: Ref<number> = ref(-1);
const stats: Ref<null | Stats> = ref(null);
onBeforeMount(() => {
	const { authorized } = AuthService;

	// Get stats
	TopService.getStats().then((_stats) => {
		if (_stats.result) {
			stats.value = _stats;
		}
	});

	// Non-authorized
	if (!authorized) {
		balance.value = 0;
		return;
	}

	// Update balance right now & every 5 mins
	updateBalance();
	setInterval(() => updateBalance(), 1000 * 60 * 5);
});

function updateBalance() {
	ProfileService.getBalance().then((userBalance) => {
		balance.value = userBalance.wrub_balance / 100;
	});
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RouterLink, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      (stats.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(stats.value.total_users), 1),
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(stats.value.total_works), 1),
            _hoisted_6
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_RouterLink, {
        to: "/notifications",
        class: "topbar__item topbar__notification"
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_9, [
        _createTextVNode(_toDisplayString(remainMinutes.value) + ":" + _toDisplayString(remainSeconds.value) + " ", 1),
        (_openBlock(), _createElementBlock("svg", _hoisted_10, [
          _createElementVNode("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M8.5 2.66659C5.55448 2.66659 3.16666 5.0544 3.16666 7.99992C3.16666 10.9454 5.55448 13.3333 8.5 13.3333C11.4455 13.3333 13.8333 10.9454 13.8333 7.99992C13.8333 5.0544 11.4455 2.66659 8.5 2.66659ZM1.83333 7.99992C1.83333 4.31802 4.8181 1.33325 8.5 1.33325C12.1819 1.33325 15.1667 4.31802 15.1667 7.99992C15.1667 11.6818 12.1819 14.6666 8.5 14.6666C4.8181 14.6666 1.83333 11.6818 1.83333 7.99992ZM8.5 4.66659C8.86819 4.66659 9.16666 4.96506 9.16666 5.33325V8.36123L10.8579 9.43748C11.1685 9.63515 11.2601 10.0472 11.0624 10.3578C10.8648 10.6685 10.4527 10.76 10.1421 10.5624L8.29645 9.38787C8.00801 9.20431 7.83333 8.88611 7.83333 8.54421V5.33325C7.83333 4.96506 8.1318 4.66659 8.5 4.66659Z",
            fill: 
							remainTime.value.getMinutes() >= 15
								? '#A3B1EE'
								: '#F84648'
						
          }, null, 8, _hoisted_11)
        ]))
      ]),
      _createVNode(_component_RouterLink, { to: "/balance" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            (balance.value !== -1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(balance.value), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("...")
                ], 64)),
            _hoisted_13
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})